import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppPreloadingStrategyService } from './preloading-strategy.service';
import { AuthGuard } from './_helpers/auth.guard';

const routes: Routes = [
    {
        path: 'profil/visites',
        redirectTo: 'visites',
    },
    {
        path: 'profil/editer/mes-albums/autorisations-acces-album-prive',
        redirectTo: '/mes-albums/autorisations'
    },
    {
        path: 'profil/editer/mes-albums/mon-album-public',
        redirectTo: '/mes-albums/mon-album-public'
    },
    {
        path: '',
        loadChildren: () =>
            import('./modules/app/app.module').then(m => m.AppPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'connexion',
        loadChildren: () =>
            import('./modules/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'mot-de-passe-oublie',
        loadChildren: () =>
            import('./modules/password/password.module').then(m => m.PasswordPageModule)
    },
    {
        path: 'mot-de-passe-oublie/reinitialiser/:token',
        loadChildren: () =>
            import('./modules/password-reset/password-reset.module').then(m => m.PasswordResetPageModule)
    },
    {
        path: 'inscription',
        loadChildren: () =>
            import('./modules/register/register.module').then(m => m.RegisterPageModule)
    },
    {
        path: 'email-non-confirme',
        loadChildren: () =>
            import('./modules/unconfirmed/unconfirmed.module').then(m => m.UnconfirmedPageModule)
    },
    {
        path: 'telephone-non-confirme',
        loadChildren: () =>
            import('./modules/confirm-mobile/confirm-mobile.module').then(m => m.ConfirmMobileModule)
    },
    {
        path: 'validation_email',
        loadChildren: () =>
            import('./modules/email-validation/email-validation.module').then(m => m.EmailValidationPageModule)
    },
    {
        path: 'desinscription-emails',
        loadChildren: () =>
            import('./modules/email-unsubscribe/email-unsubscribe.module').then(m => m.EmailUnsubscribePageModule)
    },
    {
        path: 'mentions-legales',
        loadChildren: () =>
            import('./modules/legals/legals.module').then(m => m.LegalsPageModule)
    },
    {
        path: 'welcome',
        loadChildren: () =>
            import('./modules/welcome/welcome.module').then(m => m.WelcomePageModule)
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    //   preloadingStrategy: AppPreloadingStrategyService,
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 0],
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
